import { SET_FORM_STATUS } from './';

export default status => ({ type: SET_FORM_STATUS, payload: status });
